import React from 'react';
import { FILE_INPUT_ACCEPT } from '../utils/file-upload';
import { useNotifications } from '../components/notifications/NotificationProvider';
import { showFileUploadErrorNotification } from './upload-notifications';
import { useFileUpload } from './use-file-upload';

type AddNewFileButtonProps = {
  className?: string;
};

export const AddNewFileButton: React.FC<AddNewFileButtonProps> = () => {
  const notifications = useNotifications();
  const uploadFiles = useFileUpload();

  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files ?? []);

    try {
      await uploadFiles(files);
    } catch (error) {
      showFileUploadErrorNotification(notifications, error);
    } finally {
      e.target.value = '';
    }
  };

  return (
    <label className='topbar__btn topbar__btn-secondary'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
      >
        <path d='M11 10H16V11H11V16H10V11H5V10H10V5H11V10Z' fill='#096DD9' />
      </svg>
      <span>Add new file</span>
      <input
        type='file'
        accept={FILE_INPUT_ACCEPT}
        multiple
        onChange={handleChange}
        style={{ display: 'none' }}
      />
    </label>
  );
};
